import Vue from 'vue'
import axios from 'axios'
import { VueAxios } from './axios'
// 创建 axios 实例
const service = axios.create({
  // baseURL: '/jeecg-boot',
  baseURL: process.env.API_ROOT, // api base_url
  timeout: 30000 // 请求超时时间
})
const err = error => {
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.method == 'get') {
      if (config.url.indexOf('sys/dict/getDictItems') < 0) {
        config.params = {
          _t: Date.parse(new Date()) / 1000,
          ...config.params
        }
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// response interceptor
service.interceptors.response.use(response => {
  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

export { installer as VueAxios, service as axios }



// WEBPACK FOOTER //
// ./src/utils/request.js